import { Directive, ElementRef, Input } from '@angular/core';
import { DisableIfParam } from './disableIfParameter';

/**
 * This directive will disable all child elements on an html tag and display a tooltip on hover with a 'not-allowed' cursor icon.
 * Input parameter of the following directive is an object of type 'DisableIfParam' which has disable (boolean), and message (string) attributes.
 */

@Directive({
  selector: '[disableIf]'
})
export class DisableifDirective {

  constructor(private el: ElementRef) { }

  @Input() set disableIf(param: DisableIfParam) {
    if (param.disable) {
      this.el.nativeElement.title = param.message;
      this.el.nativeElement.classList.add('not-allowed')
      this.el.nativeElement.childNodes.forEach((c:any) => c.disabled = true);
    } else {
      this.el.nativeElement.title = '';
      this.el.nativeElement.classList.remove('not-allowed')
      this.el.nativeElement.childNodes.forEach((c:any) => c.disabled = false);
    }
  }
}
